import stripHTMLTags from './stripHTMLTags'

const getExcerpt = (str: string, length: number = 120) => {
  const plainStr = stripHTMLTags(str)
  return plainStr.length > length ? `${plainStr.substr(0, length)} ...` : plainStr
}

export default getExcerpt
